import { IdNumberTypes } from "src/contexts/documentationArea/domain/IdNumberTypes";
import { IdNumberValidator } from "./IdNumberValidator";

const DNI_REGEX = /^(\d{8})([A-Z])$/;
const NIE_REGEX = /^(?:X0?\d{7}[A-Z]|[YZ]\d{7}[A-Z])$/;

export type SpanishIdNumberValidatorParams = {
  value: string;
  idNumberType: IdNumberTypes;
};

export class SpanishIdNumberValidator extends IdNumberValidator<SpanishIdNumberValidatorParams> {
  public validate({ value, idNumberType }: SpanishIdNumberValidatorParams): boolean {
    return this.validateSpanishId(value, idNumberType);
  }

  private sanitizeNIF = function (str: string): string {
    // Ensure uppercase and remove whitespace ang hyphens
    return str.toUpperCase().replace(/\s/g, "").replace(/-/g, "");
  };

  private validateSpanishId(str: string, type: IdNumberTypes) {
    str = this.sanitizeNIF(str);

    switch (type) {
      case IdNumberTypes.ID_CARD:
        return this.validateDNI(str) || this.validateNIE(str);
      default:
        throw new Error("Invalid IdNumberType to validate");
    }
  }

  private validateNIE(nie: string): boolean {
    nie = this.sanitizeNIF(nie);
    if (!nie.match(NIE_REGEX)) {
      return false;
    }
    let niePrefix = nie.charAt(0);

    switch (niePrefix) {
      case "X":
        niePrefix = "0";
        break;
      case "Y":
        niePrefix = "1";
        break;
      case "Z":
        niePrefix = "2";
        break;
      default:
        return false;
    }

    return this.validateDNI(niePrefix + nie.substring(1));
  }

  private validateDNI(dni: string): boolean {
    dni = this.sanitizeNIF(dni);
    if (!dni.match(DNI_REGEX)) {
      return false;
    }
    const dniControlLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const controlLetter = dniControlLetters.charAt(parseInt(dni, 10) % 23);

    return controlLetter === dni.charAt(8);
  }
}
